<template>
  <div class="box">
    <div class="box-header">
      <div class="col-6 col-md-6 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input v-model="filterText" @keyup.enter="doFilter" type="text" class="form-control pull-right" placeholder="Pesquisar...">
            <div class="input-group-btn">
              <button type="button" class="btn btn-info" @click="doFilter"><i class="fa fa-search"></i></button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-6 col-sm-4 col-xs-4 div-btn-novo">
        <export-excel
          :fields = "listaExcelFields"
          :fetch = "gerarExcel"
          type = "xls"
          worksheet = "Ponto de Apoio"
          name = "zanzar-apuracao-mensal.xls"
          class="btn btn-sm btn-primary btn-novo" style="width: 33px"
          data-tooltip="Exportar Excel"
        ><i class="fa fa-file-excel"></i></export-excel>
      </div>
    </div>

    <vuetable ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      pagination-path=""
      :per-page="25"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"        
      @vuetable:loaded="onLoaded"
      no-data-template="Nenhum registro encontrado"
    >
      <template slot="status_desc" slot-scope="props">
        <span class="label" v-bind:class="{
            'label-success': props.rowData.idc_status === 1,
            'label-warning': props.rowData.idc_status === 2,
            'label-info': props.rowData.idc_status === 3,
            'label-danger': props.rowData.idc_status === 4,
            'label-default': props.rowData.idc_status === 9
          }">{{ props.rowData.status_desc }}</span>
      </template>
      <template slot="actions" slot-scope="props">
        <div class="table-button-container" style="text-align: center">
          <div class="btn-group">
            <a @click="view(props.rowData)" class="btn btn-sm btn-success legitRipple" data-tooltip="Abrir" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-eye-open"></span></a>
          </div>
        </div>
      </template>
    </vuetable>

    <div class="row vuetable-pagination ui basic segment grid" style="padding: 10px">
      <vuetable-pagination-info ref="paginationInfo"
        :css="css.pagination"
        info-template="Exibindo {from} - {to} de {total}"
        no-data-template="" />

      <vuetable-pagination ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        style="margin: 0" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Vuetable, VuetablePagination, VuetablePaginationInfo } from 'vuetable-2'
import VuetableCss from './../../helpers/VuetableCss'

import ActionsLogin from '../../actions/LoginActions'
import ApuracaoMensalActions from '../../actions/ApuracaoMensalActions'

export default {
  name: 'listar',
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data () {
    return {
      listaExcelFields: {
        'Codigo': 'cd_apuracao',
        'Cod Motorista': 'cd_motorista',
        'Cod Ponto Apoio': 'cd_ponto_apoio',
        'Data': 'dt_agendada',
        'Observação': 'observacao',
        'Cod Status': 'idc_status',
        'Status': 'status_desc',
        'Criado em': 'createdAt',
        'Alterado em': 'updatedAt',
        'Motorista': 'motorista.nome',
        'CPF': 'motorista.cpf'
      },
      css: VuetableCss,
      filterText: '',
      urlApi: process.env.URL_API_BASE + '/apuracao-mensal',
      fields: [
        {
          name: 'aplicativo.descricao',
          title: 'Aplicativo',
          sortField: 'aplicativo.descricao'
        },
        {
          name: '__slot:competencia',
          title: 'Competência',
          sortField: 'competencia_ano,competencia_mes'
        },
        {
          name: 'motorista.nome',
          title: 'Motorista',
          sortField: 'motorista.nome'
        },
        {
          name: 'motorista.tel_celular',
          title: 'Telefone',
          sortField: 'motorista.tel_celular',
          callback: 'formataNumeroTelefone'
        },
        {
          name: 'viagens_realizadas',
          title: 'Viagens Realizadas',
          sortField: 'viagens_realizadas'
        },
        {
          name: '__slot:status_desc',
          title: 'Status',
          sortField: 'status_desc'
        },
        {
          name: 'created_at',
          title: 'Criado em',
          sortField: 'created_at',
          callback: 'formataData'
        },
        '__slot:actions'
      ],
      sortOrder: [
        { field: 'created_at', direction: 'desc' }
      ],
      moreParams: {}
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Listar'

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$parent.$parent.$data.showModalLoader = false
    },
    onFilterSet (filterText) {
      this.moreParams.filter = filterText

      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh()
        }
      })
    },
    doFilter () {
      this.$events.fire('filter-set', this.filterText)
    },
    view (rowData) {
      this.$router.push('/apuracao-mensal/' + rowData.cd_ocorrencia)
    },
    async gerarExcel () {
      this.$refs.vuetable.refresh()
      let res = await ApuracaoMensalActions.listarPorStatus(this.status)
      return res
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/apuracao-mensal/Relatorio.vue